import React from "react";

import Header from "./Header";
import Footer from "./Footer";

import "font-awesome/css/font-awesome.min.css";

const AppContainer = (props) => {
  const { children } = props;
  return(
    <div className="container">
      <Header />
      {React.cloneElement(children, props)}
      <Footer />
    </div>
  );
};

AppContainer.propTypes = {
  alert: React.PropTypes.bool.isRequired,
  dismissAlert: React.PropTypes.func.isRequired,
  children: React.PropTypes.object.isRequired
};

export default AppContainer;



/** WEBPACK FOOTER **
 ** ./src/components/AppContainer.js
 **/